export const removeSpecialChars = (strName, convertSpaces = false) => {
  let strNameNew = strName.replace(/[!@#$^&%*()+=\[\]\/{}:<>?,.]/g, '')

  if (convertSpaces) {
    strNameNew = strNameNew.replace(/[ ]/g, '-')
  }

  return strNameNew
}
